import ProductRangeSelectFixed from './ProductRangeSelectFixed'

export default ProductRangeSelectFixed
